import styles from './sp.module.css';

export function Sp() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <ul className={styles.linkList}>
          <li className={styles.linkItem}>
            <a href='/main/html/company'>会社概要</a>
          </li>
          <li className={styles.linkItem}>
            <a href='https://prtimes.co.jp/policy'>プライバシーポリシー</a>
          </li>
          <li className={styles.linkItem}>
            <a href='/main/html/kiyaku'>利用規約</a>
          </li>
        </ul>
        <ul className={styles.contactList}>
          <li className={styles.contactItem}>
            <a href='https://tayori.com/form/536e9f54c53fb0fa255e36237e66a8c50e2cd625'>
              報道関係者からのお問い合わせ
            </a>
          </li>
          <li className={styles.contactItem}>
            <a href='https://tayori.com/form/c5788940efb74672cc13bd2cb1d8587b3f20fcb8'>
              企業様からのお問い合わせ
            </a>
          </li>
          <li className={styles.contactItem}>
            <a href='https://tayori.com/form/81416340de36e393af7b2d7e6e707112d77c06d4'>
              一般の皆様からのお問い合わせ
            </a>
          </li>
        </ul>
        <small className={styles.copyright}>
          Copyright &copy; PR TIMES Corporation All Rights Reserved.
        </small>
      </div>
    </footer>
  );
}
